import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { DASHBOARD_WINNERS } from "../../../../../constants/AppConstants";
import { callGetLottosByStatusNoPageable } from "../../../../../services/lottoService";

const WinnersInfoGeneral = forwardRef((props, ref) => {
    const { visible, formData, onUpdate, isEdit } = props;
    const [form] = Form.useForm();
    const [lottoAvailable, setLottoAvailable] = useState([]);


    useImperativeHandle(ref, () => ({
        validate: () => form.validateFields(),
        getValues: () => form.getFieldsValue(),
    }));


    useEffect(() => {
        getLottoAvailable();

        if (visible && formData) {
            if (isEdit) {
                const initVal = {
                    ...formData,
                };

                form.setFieldsValue(initVal);
            } else if (visible && !formData) {
                form.resetFields();
            }
        }
    }, [visible, formData, isEdit, form]);


    const getLottoAvailable = async () => {
        const response = await callGetLottosByStatusNoPageable({ status: ["CLOSED"] });
        if (response) {
            setLottoAvailable(response.data);
        }
    };


    const handleChange = () => {
        const values = form.getFieldsValue();
        onUpdate({
            ...values,
        });
    };


    return (
        <Form form={form} layout="vertical" onValuesChange={handleChange}>
            <Row>
                <Col className="px-5" xs={24} sm={12} md={12}>
                    {isEdit ?
                        <Form.Item label={DASHBOARD_WINNERS.COLUMNS.LOTTO_ID} name="lottoId">
                            <Input disabled />
                        </Form.Item>
                        :
                        <Form.Item label={DASHBOARD_WINNERS.COLUMNS.LOTTO_ID} name="lottoId" rules={[{ required: true, message: "Sorteo requerido" }]}>
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Selecciona una rifa"
                                onChange={(value) => console.log("Seleccionaste lottoId:", value)}
                            >
                                {lottoAvailable.map((item) => (
                                    <Select.Option key={item.lottoId} value={item.lottoId}>
                                        {`ID: ${item.lottoId} - #${item.lottoNumber} ${item.title}`}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    }
                </Col>
                <Col className="px-5" xs={24} sm={12} md={12}>
                    <Form.Item
                        label={DASHBOARD_WINNERS.COLUMNS.FACEBOOK_LINK}
                        name="facebookLink"
                        rules={[{ required: true, message: "Link Facebook requerido" }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={12}>
                    <Form.Item
                        label={DASHBOARD_WINNERS.COLUMNS.INSTAGRAM_LINK}
                        name="instagramLink"
                        rules={[{ required: true, message: "Link Instagram requerido" }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col className="px-5" xs={24} sm={12} md={12}>
                    <Form.Item
                        label={DASHBOARD_WINNERS.COLUMNS.TICKET_NUMBER}
                        name="ticketNumber"
                        rules={[{ required: true, message: "Ticket Ganador requerido" }]}
                    >
                        <InputNumber disabled={isEdit} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
});

export default WinnersInfoGeneral;